jQuery(function($) {
	var areClipPathShapesSupported = function () {
		var base = 'clipPath';
		var prefixes = [ 'webkit', 'moz', 'ms', 'o', '' ];
		var properties = [ base ];
		var testElement = document.createElement( 'testelement' );
		var attribute = 'polygon(50% 0%, 0% 100%, 100% 100%)';

		for ( var i = 0, l = prefixes.length; i < l; i++ ) {
			var prefixedProperty = prefixes[i] + base.charAt( 0 ).toUpperCase() + base.slice( 1 ); // remember to capitalize!
			properties.push( prefixedProperty );
		}

		for ( var i = 0, l = properties.length; i < l; i++ ) {
			var property = properties[i];
			if ( testElement.style[property] === '' ) {
				testElement.style[property] = attribute;
				if ( testElement.style[property] !== '' ) {
					return true;
				}
			}
		}
		
		return false;
	};
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	if (!isSafari && areClipPathShapesSupported()) {
		$('body').addClass('parallax-supported-clip-path');
	} else {
		$('body').addClass('parallax-supported-clip');
	}
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/layout/parallax.js
// module id = 13
// module chunks = 0